import { render, staticRenderFns } from "./ListBnPrimClientVal.vue?vue&type=template&id=1b67e212&scoped=true&"
import script from "./ListBnPrimClientVal.vue?vue&type=script&lang=js&"
export * from "./ListBnPrimClientVal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b67e212",
  null
  
)

export default component.exports